import { render, staticRenderFns } from "./TransferTeamToNextRound.vue?vue&type=template&id=60cca994&scoped=true"
import script from "./TransferTeamToNextRound.vue?vue&type=script&lang=js"
export * from "./TransferTeamToNextRound.vue?vue&type=script&lang=js"
import style0 from "./TransferTeamToNextRound.vue?vue&type=style&index=0&id=60cca994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cca994",
  null
  
)

export default component.exports